import React from 'react';
import VitaminTestOrb from './VitaminTestOrb';

// Homepage promo strip that invites visitors into the vitamin self-check.
// Details (free / 14 questions / no sign-up) live on the orb and the test page —
// kept out of here to avoid repeating the same information.
const VitaminTestTeaser = () => (
  <section className="py-6 sm:py-8">
    <div className="max-w-[1320px] mx-auto px-4 sm:px-6">
      <div className="relative overflow-hidden rounded-[28px] bg-[var(--msa-ink)] text-white px-6 py-8 sm:px-12 sm:py-11">
        {/* ambient brand glow */}
        <div className="pointer-events-none absolute -right-16 -top-16 w-72 h-72 rounded-full"
          style={{ background: 'radial-gradient(circle, rgba(47,158,68,.55), transparent 70%)' }} />
        <div className="pointer-events-none absolute right-24 bottom-[-40px] w-56 h-56 rounded-full"
          style={{ background: 'radial-gradient(circle, rgba(28,126,214,.4), transparent 70%)' }} />

        <div className="relative flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-10">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-display text-[26px] sm:text-[38px] font-bold leading-[1.08] max-w-[560px] mx-auto lg:mx-0">
              Дізнайтесь, яких вітамінів бракує саме вам
            </h2>
          </div>
          <div className="shrink-0 flex justify-center">
            <VitaminTestOrb />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default VitaminTestTeaser;
